import React, { useState, useEffect } from 'react';

import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';
import { Levels, Spinner } from 'react-activity';


const WIDGET_NAME = 'place-order';
const SETTINGS_ENTRY_STUB = 'widget.place.order.';


const PlaceOrderWidget = ({app}) => {
	const theapp = app;

	var currentscheme;
	var setCurrentScheme = (scheme) => {currentscheme = scheme};

	var currentcard;
	var setCurrentCard = (card) => {currentcard = card};
	
	var currency;
	var setCurrency = (ccy) => {currency = ccy};

	var ischecking = false;
	var setIsChecking= (val) => { ischecking = val};

	const [isloading, setIsLoading] = useState(false);
	const [isprocessing, setIsProcessing] = useState(false);

	const [widgetsize, setWidgetSize] = useState('small');

	// issuing order
	const [amount, setAmount] = useState(0);
	const [amount_string, setAmountString] = useState('');

	const [balance, setBalance] = useState('');
	const [balance_string, setBalanceString] = useState('');

	const [to_address, setToAddress] = useState(null);
	
	const [order_id, setOrderId] = useState('');

	// reporting transaction
	const [tx_info, setTransactionInfo] = useState(null);
	

	const onPlaceOrder = async () => {

		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		theapp.alert('placing order ' + order_id + ' for ' + amount_string + ' to vendor ' + to_address);

	}

	const onHandleMessage = async (eventname, params) => {
		if (!params)
			return;

		switch(params.action) {
			case 'setAmount':
				onAmountChange(params.amount);
				break;
			case 'setToAddress':
				onToAddressChange(params.address);
				break;
			case 'setOrderId':
				setOrderId(params.orderid);
				break;
			default:
				break;
		}
	}

	const onRefreshPage = async (eventname, params) => {
		console.log('PlaceOrderWidget.onRefreshPage called');

		if (!ischecking) {
			console.log('calling checkNavigationState after page refresh');
			await checkNavigationState();
		}
		else {
			console.log('ischecking==true, not calling checkNavigationState');
		}

		return;
	}

	const checkNavigationState = async () => {
		console.log('PlaceOrderWidget.checkNavigationState called');

		setIsLoading(true);
		setIsChecking(true);

		let mvcmywidget = theapp.getMvcMyWidget();
		var start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		try {

			var rootsessionuuid = await theapp.getRootSessionUUID();
			var devicewallet = await theapp.getDeviceWallet();
			var walletuuid = devicewallet.uuid;
	
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);


			if (currency && currentcard) {
				let rootsessionuuid = await theapp.getRootSessionUUID();
				let devicewallet = await theapp.getDeviceWallet();
				let walletuuid = devicewallet.uuid;
		
				let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid);
						
				if (_pos !== undefined) {
					let _card_balance_int = await _pos.toInteger();
					let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, _pos);
						
					if (balance != _card_balance_int)
					setBalance(_card_balance_int);

					if (balance_string != _card_balance_string)
					setBalanceString(_card_balance_string);
				}
			}

			let widgetsize = theapp.getWidgetSize();

			if (widgetsize != 'small')
			console.log('warning: we handle only the small widget format for the moment!');

			// signal we are loaded
			await mvcmywidget.signalEvent('on_widgetloaded_message', {widget_name: WIDGET_NAME});
		}
		catch(e) {
			console.log('exception in PlaceOrderWidget.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in PlaceOrderWidget.checkNavigationState');
			setIsLoading(false);
			setIsChecking(false);

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}

	}
  

	useEffect(() => {
		console.log('PlaceOrderWidget.useEffect called');

		var mvcmywidget = theapp.getMvcMyWidget();
		var uuid = mvcmywidget.guid();

		checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err)});

		mvcmywidget.registerEventListener('on_handle_message', uuid, onHandleMessage);
		mvcmywidget.registerEventListener('on_refreshPage', uuid, onRefreshPage);
		return () => {
			mvcmywidget.unregisterEventListener('on_refreshPage', uuid);
			mvcmywidget.unregisterEventListener('on_handle_message', uuid);
		};
	}, []);

	// user inputs
	const onAmountChange = async (amount) => {
		if (!currency)
			return;

		var mvcmywidget = theapp.getMvcMyWidget();

		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		// we can check valid amount

		// format to currency
		const currency_amount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amount);
		var options = {showdecimals: true, decimalsshown: 4}
		const currency_amount_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, currency_amount, options);


		setAmount(amount);
		setAmountString(currency_amount_string);
	}


	const onToAddressChange = async (address) => {
		// we can check it is a valid address

		setToAddress(address);
	}

	// rendering
	const renderLoading = () => {
		return (
			<div className="PlaceOrderWidgetBlock">
				<div>{theapp.t('loading widget...')}</div>
				<div className="PlaceOrderWidgetLoadingBlock">
					<Levels />
				</div>
			</div>
		);
	}

	//
	// Small Size
	//
	const renderPlaceOrderSmall = () => {
		return (

			<div className="sw-PlaceOrderWidgetBlock">

				<div className="sw-PlaceOrderAmountLine">
					<span><FormLabel>{theapp.t('Amount')}</FormLabel></span>
					<span className="sw-PlaceOrderAmountInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={amount_string}
					/></span>
				</div>

				<div className="sw-PlaceOrderBalanceLine">
					<span><FormLabel>{theapp.t('Balance')}</FormLabel></span>
					<span className="sw-PlaceOrderBalanceInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={balance_string}
					/></span>
				</div>

				<div className="sw-PlaceOrderOrderIdLine">
					<span><FormLabel>{theapp.t('Order Id')}</FormLabel></span>
					<span className="sw-PlaceOrderOrderIdInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={order_id}
					/></span>
				</div>
				<div className="sw-PlaceOrderButtonLine">
					<Button  className="sw-PlaceOrderButton"
						onClick={onPlaceOrder} 
						type="submit">
						Place Order
					</Button>
				</div>

				<div className="sw-PaymenLinkVersionInfo" >{theapp.current_version}</div>

			</div>
		);
	}

	const renderViewOrderSmall = () => {
		return (
			<div>
				View Order
			</div>
		);
	}

	const renderWidget = () => {
		switch(widgetsize) {
			default:
			return (tx_info ? renderViewOrderSmall() : renderPlaceOrderSmall());
		}
	}
	


	return (
		<div className="PlaceOrderWidget">
			{(isloading ? renderLoading() :
			renderWidget())}
		</div>
	);
}

export default PlaceOrderWidget;
